import React from 'react';
import {useNavigate, useParams} from 'react-router-dom';
import {Box} from '@mui/material';
import CustomTypography from '../../../Components/CustomTypography';
import projectClasses from '../Data/projectClasses';
import itSecurityArray from "../Data/itSecurityArray";
import javaArray from "../Data/javaArray";
import pythonArray from "../Data/pythonArray";
import reactArray from "../Data/reactArray";
import reactNativeArray from "../Data/reactNativeArray";
import solidityArray from "../Data/solidityArray";
import SpecificProjectContainer from "../Components/SpecificProjectContainer";

const ProjectClassesScreen = () => {

    const {projectId} = useParams();
    const navigate = useNavigate();

    const projectClass = projectClasses.find(proj => proj.title.toLowerCase() === projectId);
    if (!projectClass) {
        return <div>Project not found</div>;
    }

    const categoryMap = {
        pythonArray,
        reactArray,
        javaArray,
        reactNativeArray,
        itSecurityArray,
        solidityArray,
    };

    const selectedProjectArray = categoryMap[projectClass.category] || [];
    const handleSpecificProjectClick = (projectName) => {
        navigate(`/projects/${projectId}/${projectName.toLowerCase()}`);
    };

    return (
        <Box sx={{
            padding: '20px',
            minHeight: '100vh',
            height: 'auto',
            maxHeight: '100%',
            display: 'flex',
            flexDirection: 'column', // Setzt den Inhalt vertikal an
            justifyContent: 'flex-start', // Zentriert den Inhalt vertikal
            alignItems: 'center', // Zentriert den Inhalt horizontal
            textAlign: 'center',
        }}
        >
            <Box
                sx={{
                    width: {
                        xs: 'calc(100% - 10px)',  // Volle Breite bei kleinen Bildschirmen
                        sm: 'calc(100% - 10px)',  // Zwei Spalten, mit Platz für den Abstand
                        md: 'calc(100% - 10px)',  // Drei Spalten
                        lg: 'calc(100% - 10px)', // Wieder zwei Spalten bei größeren Bildschirmen
                    },
                    height: {
                        xs: '100px',
                        sm: '130px',
                        md: '140px',
                        lg: '150px',
                    },
                    backgroundImage: `url(${projectClass.image})`,  // Setzt das Bild als Hintergrundbild
                    backgroundSize: 'contain',  // Bild skaliert sich, um die Box zu füllen
                    backgroundPosition: 'center',  // Zentriert das Bild in der Box
                    borderRadius: '12px',  // Runden der Box-Ecken
                    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',  // Optional: Schatten für mehr Tiefe
                    display: 'flex',  // Flexbox aktivieren
                    justifyContent: 'center',  // Horizontale Zentrierung
                    alignItems: 'center',  // Vertikale Zentrierung
                    color: 'black',  // Textfarbe, damit der Text lesbar ist
                    textShadow: '0 2px 4px rgba(0, 0, 0, 0.6)',  // Optional: Schatten hinter dem Text für bessere Lesbarkeit
                }}
            >
                <CustomTypography variant="h1"
                                  sx={{
                                      textAlign: 'center',
                                      '-webkit-text-stroke': '1px white',
                                      textStroke: '1px white',
                                      color: 'white'
                                  }}>
                        <span
                            style={{
                                backgroundColor: 'rgba(0, 0, 0, 0.9)',  // Schwarzer Hintergrund mit 50% Transparenz
                                padding: '4px 8px',  // Innenabstand für bessere Lesbarkeit
                                borderRadius: '10px',  // Runde Ecken
                            }}
                        >
                            {projectClass.title}
                        </span>
                </CustomTypography>
            </Box>
            <Box sx={{paddingTop: '20px', paddingBottom: "40px"}}>
                <CustomTypography variant="h4">{projectClass.description}</CustomTypography>
            </Box>
            <SpecificProjectContainer objectArray={selectedProjectArray} onProjectClick={handleSpecificProjectClick}/>

        </Box>
    );
}

export default ProjectClassesScreen;